var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_532_11866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 5H5.25C4.83579 5 4.5 5.33579 4.5 5.75V10.25C4.5 10.6642 4.83579 11 5.25 11H9.75C10.1642 11 10.5 10.6642 10.5 10.25V5.75C10.5 5.33579 10.1642 5 9.75 5Z",
    stroke: "#838FB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 5H14.25C13.8358 5 13.5 5.33579 13.5 5.75V10.25C13.5 10.6642 13.8358 11 14.25 11H18.75C19.1642 11 19.5 10.6642 19.5 10.25V5.75C19.5 5.33579 19.1642 5 18.75 5Z",
    stroke: "#838FB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 14H5.25C4.83579 14 4.5 14.3358 4.5 14.75V19.25C4.5 19.6642 4.83579 20 5.25 20H9.75C10.1642 20 10.5 19.6642 10.5 19.25V14.75C10.5 14.3358 10.1642 14 9.75 14Z",
    stroke: "#838FB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 14H14.25C13.8358 14 13.5 14.3358 13.5 14.75V19.25C13.5 19.6642 13.8358 20 14.25 20H18.75C19.1642 20 19.5 19.6642 19.5 19.25V14.75C19.5 14.3358 19.1642 14 18.75 14Z",
    stroke: "#838FB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_532_11866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/Menu Icon.5ea6a5b254d790e144584158ffdbec72.svg";
export { ForwardRef as ReactComponent };